namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_chat, {
		
		flex: {
			basis: '27rem',
		},

		margin: {
			left: 'auto',
		},

		Textarea: {
			height: '7rem',
			width: 'min-content',
		},

		Send: {
			height: '1rem',
			margin: {
				right: '2.5rem',
			},
		},

		Message: {
			// padding: $mol_gap.text,
			// padding: '0.25rem',
			padding: {
				left: '0.75rem',
				right: '0.75rem',
				top: '0.25rem',
				bottom: '0.75rem',
			},
		},

		Body_content: {
			gap: '0.25rem',
			justify: {
				content: 'flex-end',
			},
			minHeight: '100%',
		},

		Message_head: {
			font: {
				size: '0.8rem',
			},
			color: $mol_theme.shade,
		},

		Message_date: {
			margin: {
				left: 'auto',
			},
		},

		Message_text: {
			margin: '-0.75rem',
		},
		
	} )
	
}
